<template>
  <v-card>
    <v-card-title>
      {{ t("components.companies.credits.title") }}
    </v-card-title>
    <v-card-text>
      <div class="d-flex ga-2 my-2">
        <div
          v-for="(credit, index) in dealRates.credits"
          :key="index"
          :class="`bg-pink-4 rounded-lg pa-2 ${credit.amountUsed === credit.amount ? 'opacity-60' : ''}`"
          style="width: 300px"
        >
          {{ credit.note }}
          <v-progress-linear
            :model-value="credit.amountUsed ?? 0"
            :max="credit.amount"
            color="success"
            bg-color="black"
            :bg-opacity="0.2"
            class="mt-4"
            rounded="lg"
          />
          <p class="text-caption text-right font-italic">
            {{ n(credit.amountUsed ?? 0, "currency") }} / {{ n(credit.amount, "currency") }}
          </p>
        </div>
      </div>
      <y-btn @click="dialog = true">
        {{ t("components.companies.credits.addButton") }}
      </y-btn>
      <!-- dialog to add new credit -->
      <v-dialog v-model="dialog" max-width="500">
        <v-card>
          <v-card-title>
            {{ t("components.companies.credits.addTitle") }}
          </v-card-title>
          <v-card-text>
            <v-form>
              <v-text-field
                v-model="newCredit.amount"
                :label="t('components.companies.credits.amount')"
              />
              <v-text-field
                v-model="newCredit.note"
                :label="t('components.companies.credits.note')"
              />
              <y-btn
                :loading="loading"
                :disabled="newCredit.amount <= 0 || !newCredit.note"
                @click="addCredit"
              >
                {{ t("components.companies.credits.save") }}
              </y-btn>
            </v-form>
          </v-card-text>
        </v-card>
      </v-dialog>
    </v-card-text>
  </v-card>
</template>

<script setup lang="ts">
import { DealRates } from "@tableyeti/merchant-service";
import { onMounted, ref } from "vue";
import { useI18n } from "vue-i18n";
import { useYetipayApi } from "@/composables/useYetipayApi";

const { dealRates } = defineProps<{ dealRates: DealRates }>();
const { t, n } = useI18n();
const { api, currentMerchantId } = useYetipayApi();

const localDealRates = ref(dealRates);
const dialog = ref(false);
const loading = ref(false);
const newCredit = ref({
  amount: 0,
  note: "",
});

onMounted(() => {
  localDealRates.value = dealRates;
});

const addCredit = async () => {
  loading.value = true;
  try {
    await api.addCreditGrant(currentMerchantId, {
      amount: Number(newCredit.value.amount),
      note: newCredit.value.note,
    });
    dialog.value = false;
    localDealRates.value.credits = [
      ...(localDealRates.value.credits ?? []),
      {
        amount: Number(newCredit.value.amount),
        note: newCredit.value.note,
      },
    ];
    newCredit.value = {
      amount: 0,
      note: "",
    };
  } catch (error) {
    console.error(error);
  } finally {
    loading.value = false;
  }
};
</script>
